import OnOffToggle from 'components/generics/toggles/OnOffToggle';
import { useEffect, useState } from 'react';
import useResidentDetails from '../../../../../../../../hooks/requests/resident/useResidentDetails';

const AutopayToggle = () => {
  const { residentDetails, setAutopay } = useResidentDetails();
  const [innerIsAutopay, setInnerIsAutopay] = useState<boolean>(
    residentDetails?.isAutoPayEnabled || false
  );

  useEffect(() => {
    if (residentDetails?.isAutoPayEnabled !== undefined) {
      setInnerIsAutopay(residentDetails.isAutoPayEnabled);
    }
  }, [residentDetails]);

  const onPress = async (value: boolean) => {
    if (setAutopay) {
      const res = await setAutopay(value);
      setInnerIsAutopay(res ?? innerIsAutopay);
    }
  };

  return (
    <OnOffToggle
      isOn={innerIsAutopay}
      onChangeValue={(value) => onPress(value)}
    />
  );
};

export default AutopayToggle;
